/*
  Black Friday: the price a variant is shown at. The add-to-bag button carries
  data-bf-pct (25 or 20) on Black Friday products; variants already on sale
  keep their own price. Rounded the same way as the Liquid in
  snippets/magnum-price.liquid, so the button total matches the price shown.
*/
window.magnumShownPrice = function (variant) {
  var price = variant.price;
  var el = document.querySelector('[data-bf-pct]');
  var pct = el ? parseInt(el.dataset.bfPct, 10) : 0;
  if (pct && !(variant.compare_at_price > variant.price)) {
    // Rounded down, as Shopify rounds the basket discount, so the page matches the basket to the penny.
    price -= Math.floor((price * pct) / 100);
  }
  return price;
};

/*
  Keeps the "Add to bag - £26.28" total on the product page in step with the
  quantity box.

  Everything is delegated from the document, so it does not matter whether the
  quantity block, the buy button or the whole section is rendered late (a
  variant change re-renders the section, which brings a fresh unit price with
  it from Liquid).
*/
(function () {
  var SCOPE = 'product-info, .product__info-container';
  var QUANTITY = '.quantity__input, input[name="quantity"]';

  function formatMoney(pence, currency) {
    // Written the same way as the prices Liquid prints (see theme.liquid).
    if (window.magnumMoney) return window.magnumMoney(pence);
    var amount = pence / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        useGrouping: false,
        style: 'currency',
        currency: currency || 'GBP',
      }).format(amount);
    } catch (e) {
      return amount.toFixed(2);
    }
  }

  function update(scope) {
    if (!scope) return;
    var label = scope.querySelector('.product-form__submit-label');
    var total = scope.querySelector('.product-form__submit-total');
    if (!label || !total) return;

    var unitPrice = parseInt(label.dataset.unitPrice, 10);
    if (isNaN(unitPrice)) return;

    var input = scope.querySelector(QUANTITY);
    var quantity = input ? parseInt(input.value, 10) : 1;
    if (isNaN(quantity) || quantity < 1) quantity = 1;

    total.textContent = ' - ' + formatMoney(unitPrice * quantity, label.dataset.currency);
  }

  function updateAll() {
    document.querySelectorAll(SCOPE).forEach(update);
  }

  function onQuantityEvent(event) {
    var target = event.target;
    if (!target || !target.matches || !target.matches(QUANTITY)) return;
    update(target.closest(SCOPE));
  }

  ['input', 'change'].forEach(function (name) {
    document.addEventListener(name, onQuantityEvent, true);
  });

  // The plus/minus buttons set the value in script, which fires 'change' — but
  // guard against themes that only click, by re-checking just after a click.
  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    if (!event.target.closest('.quantity__button')) return;
    setTimeout(updateAll, 0);
  });

  // A variant change swaps the section markup for freshly rendered Liquid.
  document.addEventListener('change', function (event) {
    if (event.target.closest && event.target.closest('variant-selects, variant-radios')) {
      setTimeout(updateAll, 400);
    }
  });

  /*
    On a variant change the theme's product form writes plain "Add to bag"
    straight over the button's label, which wipes out the total inside it, and
    it never tells the label the new variant's price. So the price is set from
    the variant, the total is put back, and it is worked out again.
  */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var variant = event && event.data && event.data.variant;
      document.querySelectorAll(SCOPE).forEach(function (scope) {
        var label = scope.querySelector('.product-form__submit-label');
        if (!label) return;
        if (variant && typeof variant.price === 'number') label.dataset.unitPrice = String(window.magnumShownPrice(variant));

        var button = label.closest('.product-form__submit');
        var sellable = !(button && (button.disabled || button.hasAttribute('disabled')));
        if (sellable && !label.querySelector('.product-form__submit-total')) {
          label.textContent = label.dataset.addToBagText || 'Add to bag';
          var total = document.createElement('span');
          total.className = 'product-form__submit-total';
          label.appendChild(total);
        }
        update(scope);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAll);
  } else {
    updateAll();
  }
})();

/*
  The thumbnail strip is cropped to the height of the featured image, so when a
  product has more images than fit, a chevron sits at each end of it. Both are
  there from the start and the one with nowhere to go is dimmed, so the strip
  keeps the same shape as you scroll. On a product whose images all fit,
  neither is shown. They also stand in for the scrollbar, which is hidden in
  this layout.
*/
(function () {
  var CHEVRON_UP = 'M5 12l5-5 5 5';
  var CHEVRON_DOWN = 'M5 8l5 5 5-5';

  function makeCue(direction, label, path) {
    const cue = document.createElement('button');
    cue.type = 'button';
    cue.className = 'magnum-thumb-scroll magnum-thumb-scroll--' + direction;
    cue.setAttribute('aria-label', label);
    cue.innerHTML =
      '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false">' +
      '<path d="' + path + '" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    return cue;
  }

  function setup(slider) {
    const list = slider.querySelector('.thumbnail-list');
    if (!list || slider.dataset.magnumScrollCue) return;
    slider.dataset.magnumScrollCue = 'true';

    const up = makeCue('up', 'Show earlier images', CHEVRON_UP);
    const down = makeCue('down', 'Show more images', CHEVRON_DOWN);
    slider.appendChild(up);
    slider.appendChild(down);

    const update = () => {
      const overflow = list.scrollHeight - list.clientHeight;
      const remaining = overflow - list.scrollTop;
      // Both chevrons are present whenever the strip scrolls at all; the one
      // with nowhere to go is disabled rather than hidden.
      slider.classList.toggle('can-scroll', overflow > 8);
      up.disabled = list.scrollTop <= 8;
      down.disabled = remaining <= 8;
    };

    const step = (sign) => () => {
      list.scrollBy({ top: sign * list.clientHeight * 0.8, behavior: 'smooth' });
    };

    up.addEventListener('click', step(-1));
    down.addEventListener('click', step(1));

    list.addEventListener('scroll', update);
    window.addEventListener('resize', update);
    // Images load late and change the strip height, so re-measure after that.
    window.addEventListener('load', update);
    setTimeout(update, 600);
    update();
  }

  function init() {
    document.querySelectorAll('.product__media-wrapper .thumbnail-slider').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/*
  Side drawers opened from the delivery / click & collect panels.
  Click the panel to open, overlay, close button or Escape to shut it.
*/
(function () {
  let lastTrigger = null;
  let lockedAt = null;

  /*
    Holding the page still behind an open drawer. overflow:hidden on the body is
    ignored by Safari on iPhone, so a swipe in the drawer scrolled the product
    page behind it instead. Pinning the body in place with position:fixed - and
    putting the reader back where they were on close - works everywhere.
  */
  function lockPage() {
    if (lockedAt !== null) return;
    lockedAt = window.scrollY;
    const body = document.body.style;
    body.position = 'fixed';
    body.top = -lockedAt + 'px';
    body.left = '0';
    body.right = '0';
    body.width = '100%';
    body.overflow = 'hidden';
  }

  function unlockPage() {
    if (lockedAt === null) return;
    const body = document.body.style;
    body.position = '';
    body.top = '';
    body.left = '';
    body.right = '';
    body.width = '';
    body.overflow = '';
    // Jump straight back, without the page's smooth scrolling playing it out.
    const html = document.documentElement;
    const behaviour = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    window.scrollTo(0, lockedAt);
    html.style.scrollBehavior = behaviour;
    lockedAt = null;
  }

  function open(id, trigger) {
    const drawer = document.getElementById(id);
    if (!drawer) return;
    lastTrigger = trigger || null;
    drawer.hidden = false;
    lockPage();
    const close = drawer.querySelector('.magnum-drawer__close');
    if (close) close.focus({ preventScroll: true });
  }

  function closeAll() {
    document.querySelectorAll('.magnum-drawer:not([hidden])').forEach((d) => {
      d.hidden = true;
    });
    unlockPage();
    if (lastTrigger) {
      lastTrigger.focus({ preventScroll: true });
      lastTrigger = null;
    }
  }

  document.addEventListener('click', (event) => {
    if (!event.target.closest) return;

    const trigger = event.target.closest('[data-magnum-drawer-open]');
    if (trigger) {
      event.preventDefault();
      open(trigger.dataset.magnumDrawerOpen, trigger);
      return;
    }

    if (event.target.closest('[data-magnum-drawer-close]')) {
      event.preventDefault();
      closeAll();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAll();
  });
})();

/*
  Favourites heart.

  The heart beside the title is our own button (main-product.liquid), so it is
  always on the page rather than waiting on the Swym app to inject one. Signed
  in, it saves to and removes from the shopper's Swym wishlist; signed out, it
  goes to the login page and comes back here afterwards.

  A product counts as saved if any of its variants is on the list, and
  removing it takes every one of them off.

  Swym still injects its own full-width button into the buy row. Anything left
  there that reads as a favourites control is hidden, whichever app put it
  there.
*/
(function () {
  const fav = document.querySelector('[data-magnum-fav]');

  function looksLikeFavourite(el) {
    const marks = (typeof el.className === 'string' ? el.className : '') + ' ' + (el.id || '');
    if (/swym|wishlist|aaa-hrt|aaa-ask-the-wishlist/i.test(marks)) return true;
    return /^add(ed)?\s+to\s+favourites?$/i.test((el.textContent || '').trim());
  }

  function hideStrays() {
    document.querySelectorAll('.magnum-buy-row, .product-form').forEach((area) => {
      area.querySelectorAll('a, button, div, span').forEach((el) => {
        if (el.closest('[data-magnum-fav]')) return;
        if (!looksLikeFavourite(el)) return;
        el.classList.add('magnum-favourite-stray');
      });
    });
  }

  function start() {
    hideStrays();
    // The app renders late and re-renders on click, so keep checking.
    const timer = setInterval(hideStrays, 500);
    setTimeout(() => clearInterval(timer), 120000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  if (!fav) return;

  const productId = Number(fav.dataset.productId);
  // What the shopper last asked for; null until they touch the heart.
  let wanted = null;
  let syncing = false;
  const store = () => window.MagnumFavourites;

  function variantId() {
    const input = document.querySelector('.product-form input[name="id"]');
    return Number((input && input.value) || fav.dataset.variantId);
  }

  const onList = () => store().isSaved(productId);

  function paint(on) {
    fav.setAttribute('aria-pressed', on ? 'true' : 'false');
    fav.setAttribute('aria-label', on ? 'Remove from favourites' : 'Add to favourites');
  }

  /*
    Brings the wishlist in line with what the shopper last asked for. Taps
    made while this runs just change `wanted`, and it goes round again.
  */
  async function sync() {
    if (syncing || wanted === null) return;
    syncing = true;
    try {
      while (wanted !== onList()) {
        const goal = wanted;
        if (goal) await store().add({ epi: variantId(), empi: productId, du: fav.dataset.url });
        else await store().remove(productId);
        if (goal !== onList()) break; // Swym refused; stop rather than loop.
      }
    } catch (error) {
      console.error('Favourites:', error);
    }
    syncing = false;
    paint(onList());
  }

  fav.addEventListener('click', () => {
    if (fav.dataset.signedIn !== 'true' || !store()) {
      const back = window.location.pathname + window.location.search;
      window.location.href = '/account/login?return_url=' + encodeURIComponent(back);
      return;
    }
    const current = wanted === null ? onList() : wanted;
    wanted = !current;
    paint(wanted);
    store().note(fav, wanted);
    store().ready(sync);
  });

  // magnum-favourites.js loads after this file, so wait for the page first.
  function showSaved() {
    if (fav.dataset.signedIn !== 'true' || !store()) return;
    store().ready(() => {
      if (wanted === null) paint(onList());
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', showSaved);
  else showSaved();
})();

/*
  Countdown to the next dispatch cut-off (snippets/magnum-delivery-countdown).

  The wall clock is worked out in UK time whatever the shopper's own clock says,
  so British Summer Time and a shopper in Spain both land on the same cut-off.
*/
(function () {
  var SELECTOR = '[data-magnum-countdown]';
  var SEGMENTS = ['days', 'hours', 'minutes', 'seconds'];

  // How far the given time zone is from UTC at that exact moment.
  function zoneOffset(time, zone) {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: zone,
      hour12: false,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    }).formatToParts(new Date(time));

    var read = {};
    parts.forEach(function (part) {
      read[part.type] = part.value;
    });

    var asIfUtc = Date.UTC(
      Number(read.year),
      Number(read.month) - 1,
      Number(read.day),
      Number(read.hour) % 24,
      Number(read.minute),
      Number(read.second)
    );

    return asIfUtc - time;
  }

  // The moment a given UK date and time happens, as a plain timestamp.
  function zoneTime(year, month, day, hour, minute, zone) {
    var guess = Date.UTC(year, month, day, hour, minute, 0);
    var time = guess - zoneOffset(guess, zone);
    // One more pass settles the hour the clocks change.
    return guess - zoneOffset(time, zone);
  }

  function zoneParts(time, zone) {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: zone,
      hour12: false,
      weekday: 'short',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    }).formatToParts(new Date(time));

    var read = {};
    parts.forEach(function (part) {
      read[part.type] = part.value;
    });

    var names = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    return {
      year: Number(read.year),
      month: Number(read.month) - 1,
      day: Number(read.day),
      hour: Number(read.hour) % 24,
      minute: Number(read.minute),
      weekday: names.indexOf(read.weekday),
    };
  }


  var DAY_NAMES = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ];

  // The next dispatch day at or after "from", counted in whole UK days.
  function nextCutoff(panel, from) {
    var zone = panel.zone;
    var now = zoneParts(from, zone);
    var minutesNow = now.hour * 60 + now.minute;
    var startToday = minutesNow < panel.hour * 60 + panel.minute ? 0 : 1;

    for (var ahead = startToday; ahead < startToday + 14; ahead += 1) {
      // Midday keeps the sum clear of the hour the clocks change.
      var probe = zoneTime(now.year, now.month, now.day + ahead, 12, 0, zone);
      var probeDay = zoneParts(probe, zone);
      if (panel.days.indexOf(probeDay.weekday) === -1) continue;

      return {
        time: zoneTime(probeDay.year, probeDay.month, probeDay.day, panel.hour, panel.minute, zone),
        weekday: probeDay.weekday,
        today: ahead === 0,
        date: probeDay,
      };
    }

    return null;
  }

  function pad(value) {
    return value < 10 ? '0' + value : String(value);
  }

  // Whole days between two UK dates, ignoring the time of day on either.
  function daysBetween(from, to) {
    var a = Date.UTC(from.year, from.month, from.day);
    var b = Date.UTC(to.year, to.month, to.day);
    return Math.round((b - a) / 86400000);
  }

  /*
    The day an order placed before this cut-off would land: the first day the
    courier delivers after the warehouse sends it out.
  */
  function deliveryDay(panel, cutoff) {
    var zone = panel.zone;

    for (var ahead = 1; ahead <= 8; ahead += 1) {
      // Midday keeps the sum clear of the hour the clocks change.
      var probe = zoneTime(cutoff.date.year, cutoff.date.month, cutoff.date.day + ahead, 12, 0, zone);
      var day = zoneParts(probe, zone);
      if (panel.deliveryDays.indexOf(day.weekday) === -1) continue;
      return day;
    }

    return null;
  }

  /*
    The day the order lands, as it reads in a sentence: "today", "tomorrow",
    "on Tuesday". It is the day itself, not a deadline, so the wording says
    "on" rather than "by". Far enough out that a weekday alone is ambiguous,
    the date is spelled out instead.

    The heading and the line under it both use this, so they always name the
    same day.
  */
  function dayPhrase(panel, now, delivery) {
    if (!delivery) return null;

    var ahead = daysBetween(zoneParts(now, panel.zone), delivery);
    if (ahead <= 0) return 'today';
    if (ahead === 1) return 'tomorrow';
    if (ahead <= 6) return 'on ' + DAY_NAMES[delivery.weekday];

    var label = new Intl.DateTimeFormat('en-GB', {
      timeZone: panel.zone,
      weekday: 'long',
      day: 'numeric',
      month: 'long',
    }).format(new Date(zoneTime(delivery.year, delivery.month, delivery.day, 12, 0, panel.zone)));

    return 'on ' + label;
  }

  function paint(panel, segment, text) {
    var node = panel.values[segment];
    if (!node || node.textContent === text) return;

    node.textContent = text;
    var wrap = panel.segments[segment];
    wrap.classList.remove('is-ticking');
    // Reading the layout restarts the animation on a value that keeps changing.
    void wrap.offsetWidth;
    wrap.classList.add('is-ticking');
  }

  /*
    How long there is left, in words: "the next 2 days", "the next few hours".
    Rounded down, so it never promises more time than there is.
  */
  function howLong(left) {
    var days = Math.floor(left / 86400);
    if (days >= 2) return 'the next ' + days + ' days';
    if (days === 1) return 'the next day';

    var hours = Math.floor(left / 3600);
    if (hours >= 3) return 'the next ' + hours + ' hours';
    if (hours >= 1) return 'the next few hours';

    var minutes = Math.floor(left / 60);
    if (minutes >= 10) return 'the next ' + minutes + ' minutes';
    return 'the next few minutes';
  }

  function tick(panel) {
    var now = Date.now();

    if (!panel.cutoff || panel.cutoff.time - now <= 0) {
      panel.cutoff = nextCutoff(panel, now);
      if (!panel.cutoff) return;
    }

    var left = Math.max(0, Math.floor((panel.cutoff.time - now) / 1000));

    var phrase = dayPhrase(panel, now, deliveryDay(panel, panel.cutoff));

    if (panel.lead) {
      var lead = phrase
        ? 'Order within ' + howLong(left) + ' to get it ' + phrase + '.'
        : 'Order within ' + howLong(left) + ' for next delivery.';
      if (panel.lead.textContent !== lead) panel.lead.textContent = lead;
    }

    if (panel.heading && phrase) {
      var heading = 'Want it ' + phrase + '?';
      if (panel.heading.textContent !== heading) panel.heading.textContent = heading;
    }

    paint(panel, 'days', String(Math.floor(left / 86400)));
    paint(panel, 'hours', pad(Math.floor(left / 3600) % 24));
    paint(panel, 'minutes', pad(Math.floor(left / 60) % 60));
    paint(panel, 'seconds', pad(left % 60));

    panel.root.classList.toggle('is-urgent', left < 3600);
    panel.root.classList.add('is-ready');
  }

  function start(root) {
    if (root.dataset.countdownReady === 'true') return;
    root.dataset.countdownReady = 'true';

    function readDays(value, fallback) {
      var list = String(value || '')
        .split(',')
        .map(function (day) {
          return parseInt(day, 10);
        })
        .filter(function (day) {
          return !isNaN(day);
        });

      return list.length ? list : fallback;
    }

    var panel = {
      root: root,
      zone: root.dataset.timezone || 'Europe/London',
      hour: parseInt(root.dataset.cutoffHour, 10),
      minute: parseInt(root.dataset.cutoffMinute, 10) || 0,
      days: readDays(root.dataset.days, [1, 2, 3, 4, 5]),
      deliveryDays: readDays(root.dataset.deliveryDays, [1, 2, 3, 4, 5, 6]),
      lead: root.querySelector('[data-countdown-lead]'),
      heading: root.querySelector('[data-countdown-heading]'),
      segments: {},
      values: {},
      cutoff: null,
    };

    if (isNaN(panel.hour)) panel.hour = 16;

    SEGMENTS.forEach(function (name) {
      var wrap = root.querySelector('[data-segment="' + name + '"]');
      if (!wrap) return;
      panel.segments[name] = wrap;
      panel.values[name] = wrap.querySelector('.magnum-countdown__value');
    });

    tick(panel);
    setInterval(function () {
      tick(panel);
    }, 1000);
  }

  function startAll() {
    document.querySelectorAll(SELECTOR).forEach(start);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startAll);
  } else {
    startAll();
  }

  // A variant change re-renders the product section, bringing a fresh panel.
  document.addEventListener('shopify:section:load', startAll);
  document.addEventListener('shopify:section:select', startAll);
})();

/*
  The nav bar's height is stored in --header-height, which the pictures use to
  work out where to stop. The header only measures itself on load, so the
  figure goes stale when the window is resized and the bar changes height.
*/
(function () {
  var header = document.querySelector('.section-header');
  if (!header) return;

  var pending;

  function measure() {
    document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
  }

  window.addEventListener('resize', function () {
    clearTimeout(pending);
    pending = setTimeout(measure, 150);
  });
})();

/*
  Stepping through the pictures inside the lightbox.

  Dawn opens the lightbox on one picture and expects you to scroll the rest of
  the column. We show one at a time instead, so the arrows (and the left/right
  keys) have to move the "active" class along themselves.
*/
(function () {
  var MODAL = 'product-modal.product-media-modal';

  function items(modal) {
    return Array.prototype.slice.call(
      modal.querySelectorAll('.product-media-modal__content > [data-media-id]')
    );
  }

  function show(modal, index) {
    var all = items(modal);
    if (!all.length) return;

    if (index < 0) index = all.length - 1;
    if (index >= all.length) index = 0;

    if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();

    all.forEach(function (el, i) {
      el.classList.toggle('active', i === index);
    });

    var current = all[index];
    if (current.nodeName === 'DEFERRED-MEDIA') {
      var template = current.querySelector('template');
      if (template && template.content.querySelector('.js-youtube')) current.loadContent();
    }

    var counter = modal.querySelector('[data-lightbox-current]');
    if (counter) counter.textContent = index + 1;
  }

  function currentIndex(modal) {
    var all = items(modal);
    for (var i = 0; i < all.length; i++) {
      if (all[i].classList.contains('active')) return i;
    }
    return 0;
  }

  function step(modal, by) {
    show(modal, currentIndex(modal) + by);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-lightbox-nav]');
    if (!button) return;
    var modal = button.closest(MODAL);
    if (!modal) return;

    event.preventDefault();
    step(modal, button.dataset.lightboxNav === 'next' ? 1 : -1);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

    var modal = document.querySelector(MODAL + '[open]');
    if (!modal) return;

    event.preventDefault();
    step(modal, event.key === 'ArrowRight' ? 1 : -1);
  });

  /*
    Opening the lightbox sets the active picture from Liquid's side, so the
    counter has to catch up once the modal is on screen.
  */
  document.addEventListener('click', function (event) {
    if (!event.target.closest('.product__media-toggle')) return;
    setTimeout(function () {
      var modal = document.querySelector(MODAL + '[open]');
      if (modal) show(modal, currentIndex(modal));
    }, 50);
  });
})();

/*
  The star line at the top of the page jumps down to the reviews.

  Lipscore builds its own "Reviews (n)" anchor and then hides it, so the score
  and the vote count beside the stars are wrapped in an anchor of our own
  pointing at the same block. Lipscore renders the rating after the page has
  loaded and re-renders it on a variant change, so this keeps watching and
  re-wraps whenever a fresh rating turns up.

  The jump is done by hand rather than left to the browser, because the header
  is sticky and a plain anchor drops the heading underneath it.
*/
(function () {
  var LINK = 'magnum-rating-link';

  function target() {
    return document.getElementById('lipscore-heading') || document.getElementById('lipscore-review-list');
  }

  function wrap() {
    var group = document.querySelector('.product__info-container .lipscore-compact-rating-wrapper');
    if (!group || group.parentElement.classList.contains(LINK)) return;

    var link = document.createElement('a');
    link.className = LINK;
    link.href = '#lipscore-review-list';
    group.before(link);
    link.append(group);
  }

  /*
    Lipscore prints the count on its own - "(236)" - which does not say what
    is being counted. The word is added inside the brackets, to the closing
    ")" text node the app writes last. Its hidden "votes:" label for screen
    readers is emptied at the same time, so the line is not read out as
    "votes: 236 reviews".
  */
  function name() {
    var votes = document.querySelector('.product__info-container .lipscore-compact-rating-votes');
    if (!votes) return;

    var tail = votes.lastChild;
    if (!tail || tail.nodeType !== Node.TEXT_NODE || tail.textContent.indexOf('review') !== -1) return;

    var count = (votes.textContent.match(/\d[\d,]*/) || [''])[0];
    tail.textContent = (count === '1' ? ' review)' : ' reviews)');

    var label = votes.querySelector('.lipscore-visually-hidden');
    if (label) label.textContent = '';
  }

  /*
    The app writes its markup over several lines, and every line break between
    the score and the count draws as a space of its own - under one underline
    those show up as stray dashes either side of the number. The line breaks
    are taken out and a single space put back between score and count, so the
    underline runs unbroken from "5.0" to the closing bracket.
  */
  function tidy() {
    var group = document.querySelector('.magnum-rating-link .lipscore-compact-rating-wrapper');
    if (!group) return;

    var walker = document.createTreeWalker(group, NodeFilter.SHOW_TEXT);
    var blanks = [];

    while (walker.nextNode()) {
      var node = walker.currentNode;
      if (!node.textContent.trim() && node.textContent !== ' ') blanks.push(node);
    }

    blanks.forEach(function (node) {
      node.remove();
    });

    var votes = group.querySelector('.lipscore-compact-rating-votes');
    if (!votes) return;

    var before = votes.previousSibling;
    if (!before || before.nodeType !== Node.TEXT_NODE) votes.before(document.createTextNode(' '));
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('.' + LINK);
    if (!link) return;

    var reviews = target();
    if (!reviews) return;

    event.preventDefault();

    var header = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
    var top = reviews.getBoundingClientRect().top + window.scrollY - header - 24;
    window.scrollTo({ top: top, behavior: 'smooth' });
  });

  function run() {
    wrap();
    name();
    tidy();
  }

  function watch() {
    run();
    // The app renders late and re-renders on a variant change, so keep checking.
    var timer = setInterval(run, 500);
    setTimeout(function () {
      clearInterval(timer);
    }, 120000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();

/*
  Magnum Merits strip: the points number.

  LoyaltyLion fills the strip's span with the points its own earning rules
  award for the price written in data-lion-points-for, so nothing here works
  the number out. Liquid writes the price of the variant the page opened on,
  but a variant change does not re-render the strip, so the new price is put
  in here and LoyaltyLion is asked to draw again.

  LoyaltyLion is an app that may not be there at all - it is blocked by some
  ad blockers, and it loads late - so every step is optional and the line
  simply reads without a number if it never answers.
*/
(function () {
  var POINTS = '.magnum-merits-strip__points';

  function redraw() {
    var ll = window.loyaltylion;
    if (!ll || !ll.ui || typeof ll.ui.refresh !== 'function') return;
    try {
      // Debounced: a variant change can arrive faster than the app can draw.
      ll.ui.refresh({ debounce: true });
    } catch (e) {
      /* The page does not depend on the points showing. */
    }
  }

  function setPrice(price) {
    if (typeof price !== 'number' || isNaN(price) || price <= 0) return;

    var wanted = String(price);
    var changed = false;

    document.querySelectorAll(POINTS).forEach(function (span) {
      if (span.getAttribute('data-lion-points-for') === wanted) return;
      span.setAttribute('data-lion-points-for', wanted);
      // Clear the old number so a stale one is never left showing.
      span.textContent = '';
      changed = true;
    });

    if (changed) redraw();
  }

  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    var variant = event && event.data && event.data.variant;
    if (variant) setPrice(variant.price);
  });
})();

/*
  Product details beside the image.

  The details accordions and the FAQs are written as two columns of one section
  below the product. On a wide screen the details belong up in the buy column
  next to the photo, so the column is lifted there and the FAQs are left to run
  full width underneath.

  It is moved rather than rendered twice: the accordions are section blocks
  with their own settings, and the FAQ list reads those same blocks to avoid
  answering a question the accordions already answer. Rendering them in the
  product section instead would break both.
*/
(function () {
  var DESKTOP = window.matchMedia('(min-width: 990px)');

  function apply() {
    var column = document.querySelector('[data-magnum-details-column]');
    var buyColumn = document.querySelector('.product__info-container');
    if (!column || !buyColumn) return;

    // Looked up from the document, not from the column: once the column has
    // been moved it is no longer inside the grid.
    var grid = document.querySelector('.magnum-pdp-details__grid');

    if (DESKTOP.matches) {
      if (column.parentElement === buyColumn) return;
      // Remember where it came from so a narrow window can put it back.
      if (!column.dataset.magnumHome) {
        var home = document.createElement('div');
        home.hidden = true;
        home.dataset.magnumDetailsHome = 'true';
        column.parentElement.insertBefore(home, column);
        column.dataset.magnumHome = 'true';
      }
      buyColumn.appendChild(column);
      if (grid) grid.classList.add('magnum-pdp-details__grid--faqs-only');
      return;
    }

    var home = document.querySelector('[data-magnum-details-home]');
    if (home && column.parentElement !== home.parentElement) {
      home.parentElement.insertBefore(column, home);
      if (grid) grid.classList.remove('magnum-pdp-details__grid--faqs-only');
    }
  }

  function init() {
    apply();
    // The section can be re-rendered by the theme editor, and the window can
    // cross the breakpoint at any time.
    DESKTOP.addEventListener('change', apply);
    document.addEventListener('shopify:section:load', apply);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/*
  Blank paragraphs in pasted copy.

  Shopify's rich text editor leaves behind paragraphs holding nothing but a
  non-breaking space, and the product descriptions are full of them - the
  gloves description ends in two. Nothing is drawn, but each one still takes a
  line's height, which is where the double gaps in the details accordions came
  from.

  CSS cannot reach them: to :empty a non-breaking space is content, so the
  paragraph is not empty. They have to be found by their text.
*/
(function () {
  var SCOPES = '.magnum-pdp-details__content, .magnum-drawer__body, .product__info-container .rte';

  function isBlank(paragraph) {
    // Anything drawn rather than written stays, however little text it has.
    if (paragraph.querySelector('img, picture, iframe, video, svg, table, hr, input, button')) {
      return false;
    }
    // Written as an escape: a literal non-breaking space here would be
    // invisible to the next person reading this file.
    return paragraph.textContent.replace(/\u00a0/g, ' ').trim() === '';
  }

  function tidy(root) {
    (root || document).querySelectorAll(SCOPES).forEach(function (scope) {
      scope.querySelectorAll('p').forEach(function (paragraph) {
        if (isBlank(paragraph)) paragraph.remove();
      });
    });
  }

  function init() {
    tidy(document);
    // A variant change re-renders parts of the buy column, and the theme
    // editor re-renders whole sections.
    document.addEventListener('shopify:section:load', function (event) {
      tidy(event.target || document);
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        tidy(document);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/*
  Sticky buy bar (snippets/magnum-sticky-buy).

  Shown once the page's own buy row has scrolled up out of view, hidden again
  when it is back. The bar's controls drive the real form: its quantity is
  copied into the page's quantity box and its Add button presses the page's
  Add to bag button, so the theme's own cart handling stays exactly as it is.
  It is only on the page for products with nothing to choose.
*/
(function () {
  var SCOPE = '.product__info-container';

  function q(selector) {
    return document.querySelector(SCOPE + ' ' + selector);
  }

  function money(pence, currency) {
    if (window.magnumMoney) return window.magnumMoney(pence);
    try {
      return new Intl.NumberFormat('en-GB', { useGrouping: false, style: 'currency', currency: currency || 'GBP' }).format(pence / 100);
    } catch (e) {
      return (pence / 100).toFixed(2);
    }
  }

  function init() {
    var bar = document.querySelector('[data-magnum-sticky-buy]');
    var row = document.querySelector('.magnum-buy-row') || q('.product-form__buttons');
    if (!bar || !row || !q('.product-form__submit') || typeof IntersectionObserver === 'undefined') return;

    var input = bar.querySelector('[data-sticky-quantity]');
    var add = bar.querySelector('[data-sticky-add]');

    var unitPrice = NaN;
    var currency = 'GBP';

    /* Read fresh each time: a variant change can swap these elements out. */
    function mainButton() {
      return q('.product-form__submit');
    }
    function mainQuantity() {
      return q('.quantity__input');
    }

    function quantity() {
      var n = parseInt(input.value, 10);
      return isNaN(n) || n < 1 ? 1 : n;
    }

    /* The button carries the running total, as the page's own button does. */
    function paint() {
      var button = mainButton();
      var label = button && button.querySelector('.product-form__submit-label');
      if (label) {
        var fromLabel = parseInt(label.dataset.unitPrice, 10);
        if (!isNaN(fromLabel) && isNaN(unitPrice)) unitPrice = fromLabel;
        if (label.dataset.currency) currency = label.dataset.currency;
      }


      var blocked = !button || button.disabled || button.hasAttribute('disabled');
      add.disabled = blocked;
      if (blocked) {
        add.textContent = label ? label.textContent.replace(/\s+/g, ' ').replace(/\s*-\s*£.*$/, '').trim() : 'Sold out';
      } else {
        add.textContent = isNaN(unitPrice) ? 'Add to bag' : 'Add to bag - ' + money(unitPrice * quantity(), currency);
      }
    }

    function setQuantity(n) {
      input.value = String(Math.max(1, n));
      var main = mainQuantity();
      if (main) {
        main.value = input.value;
        main.dispatchEvent(new Event('change', { bubbles: true }));
      }
      paint();
    }

    /* ---------- events ---------- */

    bar.addEventListener('click', function (event) {
      var step = event.target.closest('[data-sticky-step]');
      if (step) {
        setQuantity(quantity() + parseInt(step.getAttribute('data-sticky-step'), 10));
        return;
      }
      if (event.target.closest('[data-sticky-add]') && !add.disabled) {
        setQuantity(quantity());
        var button = mainButton();
        if (button) button.click();
      }
    });

    input.addEventListener('change', function () {
      setQuantity(quantity());
    });

    /* The page's own quantity box changing is copied down, so the two agree. */
    document.addEventListener('change', function (event) {
      if (!event.target.matches || !event.target.matches(SCOPE + ' .quantity__input')) return;
      var n = parseInt(event.target.value, 10);
      if (!isNaN(n) && n > 0 && String(n) !== input.value) {
        input.value = String(n);
        paint();
      }
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      /* Kept for safety: a variant change still brings its own price. */
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event && event.data && event.data.variant;
        if (variant && typeof variant.price === 'number') unitPrice = window.magnumShownPrice(variant);
        paint();
      });

      /* Once something has been added the theme puts its own quantity back to
         one; the bar follows, so the next add starts from one too. */
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        input.value = '1';
        paint();
      });
    }

    /* Sold out, unavailable and the like show on the page's button first. */
    var buyButtons = row;
    new MutationObserver(paint).observe(buyButtons, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true,
    });

    paint();

    /* Only once the buy row has gone off the top of the window - not while it
       is still further down the page waiting to be reached. */
    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.hidden = !passed;
      document.documentElement.classList.toggle('has-magnum-sticky-buy', passed);
    }).observe(row);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/*
  Price match: the drawer comes back open on the thank you.

  The drawer's form is Shopify's own contact form, and it is left to post the
  ordinary way - the shop runs hCaptcha on contact forms, and a background
  post would be solving the puzzle behind Shopify's back. So the page returns
  with ?contact_posted=true, and the drawer the customer was in is opened
  again, this time showing the thank you instead of the boxes.

  The button says Sending while the post is in flight, so a slow connection
  does not look like a dead button and get clicked twice.
*/
(function () {
  function init() {
    const form = document.getElementById('PriceMatchForm');
    if (form && !form.dataset.magnumBound) {
      form.dataset.magnumBound = 'true';
      form.addEventListener('submit', () => {
        const send = form.querySelector('.magnum-pm-form__send');
        if (!send) return;
        // After the tick, so the button's own value still reaches the post.
        setTimeout(() => {
          send.disabled = true;
          send.textContent = 'Sending\u2026';
        }, 0);
      });
    }

    // Liquid has already drawn the drawer open, so this only locks the page
    // behind it - the same thing a click on the button would have done.
    if (window.location.search.indexOf('contact_posted=true') === -1) return;
    const drawer = document.getElementById('magnum-drawer-price-match');
    if (!drawer || drawer.hidden) return;
    const trigger = document.querySelector('[data-magnum-drawer-open="magnum-drawer-price-match"]');
    if (trigger) trigger.click();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
